<template>
  <div class="history">
    <div class="history-action am-margin-vertical-sm">
      <!--订单查询条件-->
      <div class="form form-inline">
        <!--门店搜索-->
        <div class="form-item">
          <div class="form-item-label">门店名称:</div>
          <div class="form-item-content">
            <cc-input
              v-model="form.storeName"
              :styleObj="{maxWidth:'300px',minWidth:'100px',width:'100%'}"
              placeholder="请输入门店名称"
              @input="handleSearchBrandStore"
              :inputlistdata="searchStoreList"
              :showinputlist="true"
              class="store-search-wrap"
              @select="checkSearchBrandStore"
              @blur="clearSearchBrandStoreBefore"
            >
              <template slot="itemText" slot-scope="props">
                <span v-if="!props.item.typeName">{{props.item.storeName}}</span>
                <span v-else>[{{props.item.typeName}}] {{props.item.storeName}}</span>
              </template>
            </cc-input>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">手机号码:</div>
          <div class="form-item-content">
            <Input placeholder="手机号码" v-model="form.consigneePhone" clearable/>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">联系人:</div>
          <div class="form-item-content">
            <Input placeholder="联系人" v-model="form.consigneeName" clearable/>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">顾客地址:</div>
          <div class="form-item-content">
            <Input placeholder="顾客地址" v-model="form.consigneeAddress" clearable />
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">订单号:</div>
          <div class="form-item-content">
            <Input placeholder="订单号" v-model="form.orderNo" clearable/>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">外卖平台订单号:</div>
          <div class="form-item-content">
            <Input placeholder="外卖平台订单号" v-model="form.extOrderId" clearable/>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">外卖平台流水号:</div>
          <div class="form-item-content">
            <Input placeholder="外卖平台流水号" v-model="form.thirdSn" clearable/>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">下单渠道:</div>
          <div class="form-item-content">
            <cc-select-check style="vertical-align: middle" :selectOptions="channelList" allDesc="全部平台" partDesc="部分平台"
                             v-model="form.fromTypeList"></cc-select-check>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">订单状态:</div>
          <div class="form-item-content">
            <cc-select style="vertical-align: middle" :options="orderStatusList" v-model="form.status"></cc-select>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">下单时间:</div>
          <div class="form-item-content">
            <cc-calendar class="dateStart am-inline-block" placeholder="下单时间从" v-model="form.startTime"
                         :backward="true">
            </cc-calendar>
            <div class="am-inline-block " style="padding: 0 5px">-</div>
            <cc-calendar class="dateStart am-inline-block" placeholder="下单时间到" v-model="form.endTime" :backward="true">
            </cc-calendar>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-content">
            <Button @click.native="handleQuery" :loading="queryLoading">
              查询
            </Button>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-content">
            <Button @click.native="handleReset" class="am-btn-cancel">重置</Button>
          </div>
        </div>
      </div>
      <!--订单查询条件-->
    </div>
    <div class="history-content am-g am-g-collapse" v-show="list.length>0">
      <!--订单列表-->
      <div class="am-u-sm-4">
        <div class="order-left ">
          <div class="order-list ">
            <div class="order-item" v-for="(item, index) in list" :key="index"
                 :class="{active: orderObj.orderId === item.orderId}" @click="checkOrder(item.orderId)">
              <div class="am-g am-g-collapse">
                <div class="am-u-sm-3 order-name am-text-truncate" :title="item.consigneeName">
                  {{item.consigneeName}}
                </div>
                <div class="am-u-sm-4 am-text-truncate">
                  <span v-if="item.countryCode" style="margin-right: 10px;border-right: 1px solid #ccc;padding-right: 10px;">{{item.countryCode}}</span>
                  {{item.consigneePhone}}
                </div>
                <div class="am-u-sm-5 am-text-truncate am-text-right">
                  {{item.createTime}}
                </div>
              </div>
              <div class="order-address">
                <span>地址：</span><span>{{item.consigneeAddress}}</span>
              </div>
              <div class="order-price">
              <span>
                订单金额：
              </span>
                <span>{{currency}}{{item.totalPrice}}</span>
              </div>
            </div>
          </div>
          <div class="paging am-padding-sm ">
            <div class="paging-contain">
              <div class="paging-item">
                第{{form.pageNow}}页
              </div>
              <div class="paging-item">
                <Button @click.native="changePaging(form.pageNow-1)" :disabled="form.pageNow<=1">上一页</Button>
              </div>
              <div class="paging-item">
                <Button @click.native="changePaging(form.pageNow+1)" :disabled="form.pageNow>=form.pageTotal">下一页
                </Button>
              </div>
              <div class="paging-item">
                共{{form.pageTotal}}页
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--订单详情-->
      <div class="am-u-sm-8">
        <div class="order-details  am-padding-horizontal-sm am-scroll">
          <div class="am-g" v-show="order.length>0">
            <div class="order-action am-text-right am-margin-vertical-sm">
              <!--api接单按钮不可用，取消订单按钮不可用-->
              <Button class="am-margin-right-sm" @click.native="showCancelOrder"
                      :disabled="orderObj.dealOrderType === 2||orderObj.status === -1">取消订单
              </Button>
              <Button class="am-margin-right-sm" @click.native="checkToUpdateOrder">修改订单</Button>
              <Button class="am-margin-right-sm" @click.native="showComplaint">催单投诉</Button>
              <Button class="am-margin-right-sm" @click.native="showAdjustStoreBefore" :loading="AdjustLoading">门店调整
              </Button>
            </div>
            <div class="am-g am-g-collapse order-base-info " v-for="(item, index) in order" :key="index">
              <template v-if="item.order">
                <div class=" order-info-item am-text-center ">
                  <div class="order-info-total ">
                    <span>订单金额</span>
                    <span>{{currency}}{{item.order.totalPrice}}</span>
                    <span>订单份数</span>
                    <span>{{item.productSum}}份</span>
                    <span>外送费</span>
                    <span>{{currency}}{{item.order. deliveryFee}}</span>
                    <span>餐盒费</span>
                    <span>{{currency}}{{item.order.mealFee}}</span>
                    <span>优惠金额合计</span>
                    <span>{{currency}}{{item.order.productPrePrice}}</span>
                  </div>
                </div>
                <div class="am-g am-margin-vertical-sm">
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">品牌名称：</div>
                      <div class="form-item-content">{{item.order.brandName}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-8 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">门店名称：</div>
                      <div class="form-item-content">{{item.order.storeName}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">订单号：</div>
                      <div class="form-item-content">{{item.order.orderNo}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">系统流水号：</div>
                      <div class="form-item-content">{{item.order.sn | isEmpty}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">第三方流水号：</div>
                      <div class="form-item-content">{{item.order.thirdSn | isEmpty}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item ">
                    <div class="form-item">
                      <div class="form-item-label">第三方订单号：</div>
                      <div class="form-item-content">{{item.order.extOrderId | isEmpty}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-8 order-info-item am-u-end">
                    <div class="form-item">
                      <div class="form-item-label">下单渠道：</div>
                      <div class="form-item-content">{{item.order.fromTypeName}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-8 order-info-item am-u-end">
                    <div class="form-item">
                      <div class="form-item-label">实际下单渠道：</div>
                      <div class="form-item-content">{{item.actualOrderChannelName | isEmpty}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">取餐类型：</div>
                      <div class="form-item-content">{{item.order.orderTypeName}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">下单时间：</div>
                      <div class="form-item-content">{{item.order.createTime}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">预送达时间：</div>
                      <div class="form-item-content">{{item.order.sendTime}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">订餐人：</div>
                      <div class="form-item-content">{{item.order.consigneeName}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">联系电话：</div>
                      <div class="form-item-content"><span v-if="item.order.consigneePhoneCountryCode" style="margin-right: 10px;border-right: 1px solid #ccc;padding-right: 10px;">{{item.order.consigneePhoneCountryCode}}</span>{{item.order.consigneePhone}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item" v-if="item.order.vipPhone">
                    <div class="form-item">
                      <div class="form-item-label">会员电话：</div>
                      <div class="form-item-content">{{item.order.vipPhone}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">就餐人数：</div>
                      <div class="form-item-content">{{item.order.peopleNum}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">送餐地址：</div>
                      <div class="form-item-content">{{item.order.consigneeAddress}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">下单方式：</div>
                      <div class="form-item-content">{{item.order.fromTypeNote | isEmpty}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item" v-if="isColaCupConversionListeningSet">
                    <div class="form-item">
                      <div class="form-item-label">杯听情况：</div>
                      <div class="form-item-content">{{ item.order.cupListeningSet | cupListeningSetType}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-12 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">客户备注：</div>
                      <div class="form-item-content">{{item.order.userNote | isEmpty}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-12 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">商家备注：</div>
                      <div class="form-item-content">{{item.order.storeNoteContent | isEmpty}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">是否已支付：</div>
                      <div class="form-item-content">{{item.order.isPayed | isBoolen}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">支付方式：</div>
                      <div class="form-item-content">{{item.order.payTypeName}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">支付信息：</div>
                      <div class="form-item-content">
                      <span >{{item.order.paymentDetails | offlinePays }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">是否开发票：</div>
                      <div class="form-item-content">{{item.order.isInvoice | isBoolen}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">发票类型：</div>
                      <div class="form-item-content">{{item.order.invoiceTypeName | isEmpty}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">发票抬头：</div>
                      <div class="form-item-content">{{item.order.invoiceDesc | isEmpty}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-12 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">发票税号：</div>
                      <div class="form-item-content">{{item.order.taxNo | isEmpty}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-12 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">本单优惠：</div>
                      <div class="form-item-content">
                        <div v-for="(item, index) in item.order.orderPreferentials" :key="index">
                          {{item.type | preferentialType(item.childType)}}{{item.content}}{{currency}} {{item.price}}
                        </div>
                        <div v-if="item.order.orderPreferentials.length === 0">无</div>
                      </div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">配送公司：</div>
                      <div class="form-item-content">{{item.order.driverName}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">骑手姓名：</div>
                      <div class="form-item-content">
                        {{item.order.orderDrivers | getKeys('name')}}
                      </div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">骑手电话：</div>
                      <div class="form-item-content">{{item.order.orderDrivers | getKeys('phone')}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item">
                    <div class="form-item">
                      <div class="form-item-label">第三方物流单号：</div>
                      <div class="form-item-content">{{item.logisticsNo | isEmpty}}</div>
                    </div>
                  </div>
                  <div class="am-u-sm-4 order-info-item am-u-end">
                    <div class="form-item">
                      <div class="form-item-label">是否平台配送：</div>
                      <div class="form-item-content">{{item.order.isThirdDistribute | isBoolen}}</div>
                    </div>
                  </div>
                </div>
                <div class="order-tabs am-cf">
                  <Tabs>
                    <TabPane label="产品信息">
                      <div class="am-margin-bottom-sm" v-for="(item, index) in item.order.orderProducts" :key="index">
                        <table class="order-table ">
                          <thead class="order-table-head">
                          <tr>
                            <th class="w200">产品名称</th>
                            <th class="w300">特殊要求</th>
                            <th class="w90">分袋</th>
                            <th class="w90">单价</th>
                            <th class="w90">数量</th>
                            <th class="w90">合计</th>
                          </tr>
                          </thead>
                          <tbody class="order-table-body">
                          <tr>
                            <td>{{item.products? '套餐' : '单品'}}：{{item.name}}</td>
                            <td>
                          <span v-for="(item, index) in item.listRequirements" :key="index">
                            <span>{{item.propertys | formatAdditional}}</span>
                          </span>
                            </td>
                            <td>
                            </td>
                            <td>{{item.price}}</td>
                            <td>{{item.num}}</td>
                            <td>{{item.realTimeTotalPrice}}</td>
                          </tr>
                          </tbody>
                        </table>
                        <template v-if="item.products&&item.products.length>0">
                          <div class="am-margin-top-sm">
                            <table class="order-table order-combo">
                              <tbody class="order-table-body">
                              <tr>
                                <td class="w200 am-text-center">套餐内容</td>
                                <td>
                                  <table class="order-table order-table-striped">
                                    <thead class="order-table-head">
                                    <tr>
                                      <th class="w200">
                                        名称
                                      </th>
                                      <th class="w90">
                                        数量
                                      </th>
                                      <th class="w90">
                                        价钱
                                      </th>
                                      <th class="w300">
                                        特殊要求
                                      </th>
                                    </tr>
                                    </thead>
                                    <tbody class="order-table-body">
                                    <tr v-for="(item, index) in item.products" :key="index">
                                      <td>{{item.name}}</td>
                                      <td>{{item.num}}</td>
                                      <td>{{item.totalPrice}}</td>
                                      <td>
                                        <span v-for="(item, index) in item.listRequirements" :key="index">
                                          <span>{{item.propertys | formatAdditional}}</span>
                                        </span>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </td>
                              <tr/>
                              </tbody>
                            </table>
                          </div>
                        </template>
                      </div>
                    </TabPane>
                    <TabPane label="订单记录">
                      <table class="order-table ">
                        <thead class="order-table-head">
                        <tr>
                          <th>时间</th>
                          <th class="w90">订单状态</th>
                          <th class="w90">配送状态</th>
                          <th class="w90">操作人</th>
                          <th class="am-text-not-line">状态持续时间</th>
                          <th>备注</th>
                        </tr>
                        </thead>
                        <tbody class="order-table-body">
                        <template v-if="item.infoRecords">
                          <tr v-for="(item, index) in item.infoRecords" :key="index">
                            <td class="am-text-not-line">{{item.createTime}}</td>
                            <td class="am-text-not-line">{{item.statusName}}</td>
                            <td class="am-text-not-line">{{item.deliveryStatus | driverStatus}}</td>
                            <td class="am-text-not-line">{{item.operaterName}}</td>
                            <td class="am-text-not-line">{{item.durTime}}</td>
                            <td>{{item.sysNote}}</td>
                          </tr>
                        </template>
                        </tbody>
                      </table>
                    </TabPane>
                    <TabPane label="催单投诉">
                      <table class="order-table ">
                        <thead class="order-table-head">
                        <tr>
                          <th>反馈时间</th>
                          <th class="w90">反馈类型</th>
                          <th>反馈内容</th>
                          <th class="w90">操作人</th>
                          <th class="w300">
                            <div class=" am-g">
                              <div class="am-u-sm-4">
                                回复内容
                              </div>
                              <div class="am-u-sm-5">
                                回复时间
                              </div>
                              <div class="am-u-sm-3">
                                回复人
                              </div>
                            </div>
                          </th>
                        </tr>
                        </thead>
                        <tbody class="order-table-body">
                        <tr v-for="(item, index) in item.orderWarningRecords" :key="index">
                          <td class="am-text-not-line">{{item.createTime}}</td>
                          <td>{{item.operationType | operationType }}</td>
                          <td>{{item.text}}</td>
                          <td>{{item.operatorName}}</td>
                          <td class="w320">
                            <div class="am-g am-word-wrap am-margin-bottom-sm" v-for="(item, index) in item.replyList"
                                 :key="index">
                              <div class="am-u-sm-4 ">
                                <div class="am-padding-right-sm ">{{item.replyText}}</div>
                              </div>
                              <div class="am-u-sm-5 ">
                                <div class="am-padding-right-sm ">{{item.createTime}}</div>
                              </div>
                              <div class="am-u-sm-3 ">
                                <div class="am-padding-right-sm ">{{item.operaterName}}</div>
                              </div>
                            </div>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        </tbody>
                      </table>
                    </TabPane>
                    <TabPane label="退款记录">
                      <table class="order-table ">
                        <thead class="order-table-head">
                        <tr>
                          <th class="w90">退款状态</th>
                          <th>原因</th>
                          <th class="w90">退款类型</th>
                          <th class="w90">退款餐品</th>
                          <th class="w90">操作人</th>
                          <th class="w200">处理时间</th>
                          <th class="w90">备注</th>
                        </tr>
                        </thead>
                        <tbody class="order-table-body">
                        <tr v-for="(item, index) in item.orderApplyReCords" :key="index">
                          <td class="am-text-not-line">{{item.refundStatusName}}</td>
                          <td>{{item.reason}}</td>
                          <td class="am-text-not-line">{{item.refundType | refundType }}</td>
                          <td>
                            <div v-for="(item, index) in item.orderRefundProducts" :key="index">
                              {{item.pname}} - {{item.num}}份
                            </div>
                          </td>
                          <td>{{item.operatorName}}</td>
                          <td>{{item.createTime}}</td>
                          <td></td>
                        </tr>
                        </tbody>
                      </table>
                    </TabPane>
                    <TabPane label="修改记录">
                      <table class="order-table ">
                        <thead class="order-table-head">
                        <tr>
                          <th class="am-text-not-line">操作时间</th>
                          <th>修改内容</th>
                          <th class="am-text-not-line">操作人</th>
                        </tr>
                        </thead>
                        <tbody class="order-table-body">
                        <tr v-for="(item, index) in item.orderChanges" :key="index">
                          <td class="am-text-not-line">{{item.createTime}}</td>
                          <td>{{item.changeDetails}}</td>
                          <td class="am-text-not-line">{{item.operaterName}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </TabPane>
                    <TabPane label="支付详情">
                      <table class="order-table">
                        <thead class="order-table-head">
                          <tr>
                            <th>支付详情</th>
                            <th>备注</th>
                            <th class="am-text-not-line">操作人</th>
                            <th class="am-text-not-line">时间</th>
                          </tr>
                        </thead>
                        <tbody class="order-table-body">
                          <tr v-for="(item, index) in item.orderChangePayDetailList" :key="index">
                            <td>{{item.paymentDetailList| offlinePays}}</td>
                            <td>{{item.remark | isEmpty}}</td>
                            <td>{{item.handlePerson | isEmpty}}</td>
                            <td>{{item.changeTime}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </TabPane>
                  </Tabs>
                </div>
              </template>
            </div>
          </div>
          <cc-loading-box class="loading-box" :isLoading="isOrderLoading"></cc-loading-box>
        </div>
      </div>
    </div>
    <div class="order-empty am-padding-vertical-xl" v-show="list.length === 0 && !queryLoading">
      查无数据
    </div>
    <!--催单投诉-->
    <Modal v-model="complaint.visible" width="850px">
      <div slot="header">催单投诉</div>
      <div class="form complaint">
        <div class="form-item">
          <div class="form-item-label">
            类型：
          </div>
          <div class="form-item-content">
            <RadioGroup v-model="complaint.checkValue">
              <Radio :label="item.id" v-for="(item, index) in complaint.type" custom :key="index">
                <div slot-scope="{ currentValue }" class="am-button-custom" :class="{active: currentValue}">
                  {{item.name}}
                </div>
              </Radio>
            </RadioGroup>
          </div>
        </div>
        <!--催单-->
        <template v-if="complaint.checkValue === 2">
          <div class="form-item">
            <div class="form-item-label">
              催单时间：
            </div>
            <div class="form-item-content">
              <cc-select :options="complaint.callOrderTypeList" v-model="complaint.reminderValue" placeholder="请选择催单时间"
                         style="vertical-align: middle" valueKey="id" labelKey="name"></cc-select>
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">
              备注：
            </div>
            <div class="form-item-content">
              <div class="am-textarea-wrap">
                <textarea maxlength="150" class="am-textarea" v-model="complaint.reminderText">
                </textarea>
              </div>
            </div>
            <div class="form-item-content">
              <span class="am-padding-left-sm" style="color:#aaa">
                 *必填，最多还可以输入{{150 - complaint.reminderText.length}}字
              </span>
            </div>
          </div>
        </template>
        <!--投诉-->
        <template v-else-if="complaint.checkValue === 3">
          <div class="form-item" v-if="complaint.complaintBigReason.length">
            <div class="form-item-label">
              投诉类型：
            </div>
            <div class="form-item-content">
              <cc-select :options="complaint.complaintBigReason" v-model="complaint.complaintBigValue"
                         @change="checkComplaintBig" style="vertical-align: middle" :width="160" valueKey="id"
                         labelKey="name"></cc-select>
            </div>
            <div class="form-item-content am-padding-left-sm" v-if="complaint.complaintSmallReason.length">
              <cc-select :options="complaint.complaintSmallReason" v-model="complaint.complaintSmallValue"
                         style="vertical-align: middle" :width="160" valueKey="id" labelKey="name"></cc-select>
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">
              备注：
            </div>
            <div class="form-item-content">
              <div class="am-textarea-wrap">
                <textarea maxlength="150" class="am-textarea" v-model="complaint.complaintText">
                </textarea>
              </div>
            </div>
            <div class="form-item-content">
              <span class="am-padding-left-sm" style="color:#aaa">
                  *必填，最多还可以输入{{150 - complaint.complaintText.length}}字
              </span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="form-item">
            <div class="form-item-label">
              备注：
            </div>
            <div class="form-item-content">
              <div class="am-textarea-wrap">
                <textarea maxlength="150" class="am-textarea" v-model="complaint.remindText">
                </textarea>
              </div>
            </div>
            <div class="form-item-content">
              <span class="am-padding-left-sm" style="color:#aaa">
                 *必填，最多还可以输入{{150 - complaint.complaintText.length}}字
              </span>
            </div>
          </div>
        </template>
      </div>
      <div slot="footer" class="am-text-right">
        <Button @click.native="addOrderWarning" :disabled="!isComplaintDisabled">确认</Button>
        <Button @click.native="complaint.visible = false" class="am-btn-cancel">放弃</Button>
      </div>
    </Modal>
    <!--取消原因-->
    <Modal v-model="orderCancel.visible" width="850px">
      <div slot="header">提示</div>
      <div class="form order-cancel-form">
        <div class="form-item">
          <div class="form-item-label">请选择取消原因</div>
          <div class="form-item-content">
            <cc-select :options="orderCancel.reasonList" v-model="orderCancel.reasonValue"
                       style="vertical-align: middle" valueKey="index" labelKey="name"
                       @change="checkBigCancelReasons"></cc-select>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">二级取消原因</div>
          <div class="form-item-content">
            <cc-select :options="orderCancel.childReasonList" v-model="orderCancel.childReasonValue"
                       style="vertical-align: middle" valueKey="index" labelKey="name"></cc-select>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item-label">取消备注</div>
          <div class="form-item-content">
            <div class="am-textarea-wrap">
                <textarea maxlength="150" class="am-textarea" v-model="orderCancel.tips">
                </textarea>
            </div>
          </div>
          <div class="form-item-content">
              <span class="am-padding-left-sm" style="color:#aaa">
                 *必填，最多还可以输入{{150 - orderCancel.tips.length}}字
              </span>
          </div>
        </div>
      </div>
      <div slot="footer" class="am-text-right">
        <Button :disabled="!orderCancel.reasonValue||!orderCancel.childReasonValue||!orderCancel.tips"
                @click="changeOrderStatus">保存
        </Button>
        <Button @click.native="orderCancel.visible = false" class="am-btn-cancel">放弃</Button>
      </div>
    </Modal>
    <!--门店调整-->
    <Modal v-model="adjustStore.visible" width="850px">
      <div slot="header">选择门店</div>
      <div class="am-g">
        <div class="form form-inline">
          <div class="form-item">
            <div class="form-item-label">门店名称</div>
            <div class="form-item-content">
              <cc-input
                v-model="adjustStore.storeName"
                :styleObj="{maxWidth:'300px',minWidth:'100px',width:'100%'}"
                placeholder="请输入门店名称"
                @input="handleSearchStore"
                :inputlistdata="adjustStore.searchStoreList"
                :showinputlist="true"
                class="store-search-wrap"
                @select="checkSearchStore"
                @blur="clearSearchStore"
              >
                <template slot="itemText" slot-scope="props">
                  <span v-if="!props.item.typeName">{{props.item.storeName}}</span>
                  <span v-else>[{{props.item.typeName}}] {{props.item.storeName}}</span>
                </template>
              </cc-input>
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">行政区域</div>
            <div class="form-item-content">
              <cc-select :options="adjustStore.districtList" v-model="adjustStore.districtId"
                         style="vertical-align: middle" valueKey="districtId" labelKey="name"></cc-select>
            </div>
          </div>
          <div class="form-item ">
            <Button :loading="adjustStore.queryLoading" @click="queryAdjustableStoreList">查询</Button>
            <Button class="am-margin-left-sm" @click="resetAdjustableStore">重置</Button>
          </div>
        </div>
        <table class="am-table am-table-bordered">
          <thead>
          <tr>
            <th class="w90">操作</th>
            <th>门店名称</th>
            <th class="w90">距离(米)</th>
            <th>行政区域</th>
            <th>门店电话</th>
            <th>门店地址</th>
            <th>营业时间</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in adjustStore.storeList" :key="index">
            <td>
              <Button type="info" @click.native="submitAdjustStore(item)" :loading="item.loading">选择</Button>
            </td>
            <td>{{item.storeName}}</td>
            <td>{{item.distance}}</td>
            <td>{{item.districtName}}</td>
            <td>
              <div v-for="(item, index) in item.phoneNumberList" :key="index">
                {{item}}
              </div>
            </td>
            <td>{{item.storeAddress}}</td>
            <td>
              <div v-for="(item, index) in item.serviceTime" :key="index">
                {{item.beginTime}} - {{item.endTime}}
              </div>
            </td>
          </tr>
          <tr v-if="adjustStore.storeList.length === 0">
            <td colspan="7" class="am-text-center">查无数据</td>
          </tr>
          </tbody>
        </table>
        <div class="paging am-padding-sm ">
          <div class="paging-contain">
            <div class="paging-item">
              第{{adjustStore.pageNow}}页
            </div>
            <div class="paging-item">
              <Button @click.native="changeAdjustStorePaging(adjustStore.pageNow-1)" :disabled="adjustStore.pageNow<=1">
                上一页
              </Button>
            </div>
            <div class="paging-item">
              <Button @click.native="changeAdjustStorePaging(adjustStore.pageNow+1)"
                      :disabled="adjustStore.pageNow>=adjustStore.pageTotal">下一页
              </Button>
            </div>
            <div class="paging-item">
              共{{adjustStore.pageTotal}}页
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="am-text-right">
        <Button @click.native="adjustStore.visible = false" class="am-btn-cancel">放弃</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {mapState} from 'vuex';
  import {format, each, formatTime, find, isTel, throttle} from '@/utils/assist';
  import Tabs from '@/components/Tabs/index';
  import TabPane from '@/components/TabPane';
  import Button from '@/components/Button';
  import Input from '@/components/Input';
  import Calendar from '@/components/Calendar';
  import Modal from '@/components/Modal';
  import RadioGroup from '@/components/RadioGroup/index';
  import Radio from '@/components/Radio/index';
  import CcSelect from '@/components/Select/index';
  import LoadingBox from '@/components/Cc-Loading/index';
  import CcInput from '@/components/Cc-Input';
  import CcSelectCheck from '@/components/Cc-SelectCheck';

  const preferentialType = {
      1: '第三方优惠',
      2: '优惠折扣',
      3: '优惠券',
      5: '门店配送费优惠',
      6: '手动打折',
      7: '会员优惠'
    },
    childPreferentialType = {
      1: {1: '红包', 2: '满减', 3: '特价菜', 4: '满送'},
      2: {1: '满送', 2: '满加', 3: '满减', 4: '折扣', 6: '下单分享', 7: '进店领券', 8: '下单返券'},
      7: {1: '会员折扣', 2: '满减', 3: '优惠券', 4: '满加', 5: '满送', 6: '餐品折扣'}
    },
    driverStatusType = {
      0: '尚未派单初始状态',
      1: '呼叫中',
      2: '待接单',
      3: '确认中',
      4: '待转派',
      5: '已分配',
      6: '已到店',
      7: '配送中',
      10: '已送达',
      11: '自动送达',
      12: '取消中',
      13: '待取消',
      15: '已取消',
      16: '加小费',
      [-1]: '呼叫失败',
      [-2]: '错误信息',
      [-3]: '取消失败'
    },
    form = JSON.stringify({
      storeName: "",
      storeId: null,//门店ID
      consigneePhone: null, // 联系电话
      consigneeName: null, //联系人
      consigneeAddress: null, // 联系人地址
      orderNo: null, //订单号
      extOrderId: null, // 外卖平台订单号
      thirdSn: null, // 第三方平台流水
      status: null,
      fromTypeList: [], // 订单渠道集合
      startTime: format(Date.now(), 'yyyy-MM-dd'),
      endTime: format(Date.now(), 'yyyy-MM-dd'),
      pageNow: 1,
      pageSize: 10,
      pageTotal: 0,
    });
  export default {
    filters: {
      // 优惠类型字段显示
      preferentialType(type, childType) {
        let str = preferentialType[type] + '：',
          child;
        if (child = childPreferentialType[type]) {
          str += child[childType] || ''
        }
        return str
      },
      // 退款类型格式
      refundType(value) {
        let msg;
        switch (value) {
          case 0:
            msg = '未完成单申请';
            break;
          case 1:
            msg = '完成单申请';
            break;
          case 2:
            msg = '部分餐品退款';
            break
        }
        return msg
      },
      // 杯听选项
      cupListeningSetType(value) {
        let msg;
        switch (value) {
          case 1:
            msg = ' 无';
            break;
          case 2:
            msg = '可乐（杯）';
            break;
          case 3:
            msg = '可乐（听）';
            break;
        }
        return msg;
      },
      // 业务类型
      operationType(value) {
        let msg;
        switch (value) {
          case 1:
            msg = '提醒';
            break;
          case 2:
            msg = '催单';
            break;
          case 3:
            msg = '投诉';
            break
        }
        return msg
      },
      // 骑手状态
      driverStatus(value) {
        return driverStatusType[value]
      },
      // 对特殊要求进行格式转换
      formatAdditional(value) {
        let str = '';
        if (value) {
          each(value, (value) => {
            each(value.items, (value) => {
              str += `${value.name}(价格: ${window.currency}${value.price})`
            })
          })
        }
        return str
      },
      isEmpty(value) {
        return value || '无';
      },
      isBoolen(value) {
        return value ? '是' : '否';
      },
      getKeys(value, key) {
        let msg = '',
          arr = [];
        each(value, (value) => {
          value[key] && arr.push(value[key])
        });
        msg += arr.join(',');
        return msg
      },
      offlinePays (list = []) {
        list = list.map(item => `${item.typeName}${window.currency}${item.money}`);
        return list.join(',');
      }
    },
    created() {
      // 默认来电电话，以及收货人电话
      let _this = this;
      this.getPlatformByKey();
      find([this.userPhone, this.phone], (value) => {
        if (isTel(value)) {
          _this.form.consigneePhone = value;
          return true
        }
      });
      this.getOrderStatus().then(() => {
        _this.getOrderList()
      });
    },
    data() {
      return {
        searchStoreList: [],
        orderProductOwns: [], // 原提交订单餐品数据
        channelIdAll: [], // 全部渠道ID
        channelList: [], // 渠道列表
        orderStatusList: [], // 订单状态列表
        order: [], // 订单列表
        orderObj: {},
        isOrderLoading: false,
        orderId: null,
        list: [], // 订单列表
        // date,
        form: JSON.parse(form),
        queryLoading: false,
        AdjustLoading: false,
        orderCancel: { // 取消订单
          visible: false,
          reasonValue: 0,
          childReasonValue: 0,
          tips: '',
          reasonList: [{name: '请选择原因', index: 0}],
          childReasonList: [{name: '请选择原因', index: 0}]
        },
        adjustStore: {// 门店调整
          storeName: null,
          visible: false,
          storeId: null,
          queryLoading: false,
          districtId: 0,
          districtList: [],
          storeList: [],
          searchStoreList: [],
          selectStoreLoading: false,
          pageNow: 1,
          pageSize: 20,
          pageTotal: 0,
        },
        complaint: { // 催单投诉 complaintText投诉文本 reminderText 催单文本 remind 提醒文本
          visible: false,
          checkValue: 2,
          type: [{name: '催单', id: 2}, {name: '投诉', id: 3}, {name: '提醒', id: 1}],
          complaintText: '',
          reminderText: '',
          remindText: '',
          callOrderTypeList: [],
          complaintBigReason: [],
          complaintSmallReason: [],
          reminderValue: null,
          complaintBigValue: null,
          complaintSmallValue: null
        }
      }
    },
    mounted() {
    },
    computed: {
      isComplaintDisabled() {
        // 1提醒 2 催单 3 投诉
        let {complaint} = this, msg = '',
          {visible, checkValue, reminderText, reminderValue, callOrderTypeList, remindText, complaintBigReason, complaintSmallReason, complaintBigValue, complaintSmallValue, complaintText} = complaint;
        if (visible) {
          switch (checkValue) {
            case 1:
              msg += remindText;
              break;
            case 2:
              if (reminderValue && reminderText) {
                find(callOrderTypeList, (value) => {
                  if (value.id === reminderValue) return msg += `【${value.name}】`
                });
                msg += reminderText
              }
              break;
            case 3:
              if (complaintText) {
                let reason = [];
                find(complaintBigReason, (value) => {
                  if (value.id === complaintBigValue) return reason.push(value.name)
                });
                find(complaintSmallReason, (value) => {
                  if (value.id === complaintSmallValue) return reason.push(value.name)
                });
                msg+= reason.length ? `【${reason.join('-')}】` : '';
                msg += complaintText
              }
              break
          }
        }
        return msg
      },
      ...mapState({
        oprInfo: state => state.booking.user.oprInfo, // 营运商配置信息
        store: state => state.booking.store.data,
        storeId: state => state.booking.user.storeId,
        brandId: state => state.booking.user.brandInfo.brandId,
        platformKey: state => state.booking.user.brandInfo.platformKey,
        userPhone: state => state.booking.user.data.phone,
        phone: state => state.booking.user.phone,
        isSendOrder: state => state.booking.user.isSendOrder,
        orderAmend: state => state.booking.user.orderAmend,
        newAmend: state => state.booking.user.newAmend,
      }),
      isColaCupConversionListeningSet () { // 是否配置可乐杯转听
        return !!this.oprInfo.colaCupConversionListeningSet
      },
      currency() {
        return this.oprInfo.currencySymbol
      }
    },
    watch: {
    },
    methods: {
      throttle: throttle(),
      checkToUpdateOrder() {
        // 修改订单确认
        let orderObj = this.orderObj,
          orderId = orderObj.orderId;
        if (orderId) {
         this.server.get({
            name: 'checkToUpdateOrder',
            data: {
              orderId,
              isIntercept: true
            }
          }).then((res) => {
            if (res.status === 1) {
              return this.startOrderAmendAction(orderObj)
            } else {
              if (res.status === 3) {
                return this.$Modal.confirm({
                  title: '提示',
                  content: '是否进行强制解锁',
                  onOk: () => {
                   this.removeLockToUpdateOrder(orderId, orderObj)
                  }
                });
              }
              this.$Modal.error({title: '提示', content: res.msg})
            }
          })
        }
      },
      removeLockToUpdateOrder (orderId, orderObj) {
        // 强行解锁
        this.server.get({
          name: 'removeLockToUpdateOrder',
          data: {
            orderId
          }
        }).then((res) => {
          if (res.status === 1) {
            this.startOrderAmendAction(orderObj)
          }
        })
      },
      startOrderAmendAction(orderObj) { // 修改订单开始

        setTimeout(() => {
          if(this.newAmend) {
            // this.$store.commit('booking/user/update', {
            //   orderAmend: {
            //     ...this.orderAmend,
            //     isAmend: false,
            //     update: true,
            //     orderId: orderObj.orderId,
            //   },
            //   orderId: orderObj.orderId,
            // });
            let opType = localStorage.getItem('operatorType')
            let opName = localStorage.getItem('operatorName')
            window.location.href = window.location.origin + `/?orderId=${orderObj.orderId}&platformKey=${this.platformKey}&operatorType=${opType}&operatorName=${opName}#/customer`;
            window.location.replace();
            // this.$router.push({
            //   name: `/?orderId=${orderObj.orderId}&platformKey=${platformKey}&operatorType=${opType}&operatorName=${opName}#/customer`,
            // })
          }else {
            this.$store.commit('booking/user/update', {
              orderAmend: {
                ...this.orderAmend,
                update: true,
                orderId: orderObj.orderId,
              },
              orderId: orderObj.orderId,
            });
            this.$router.push({
              name: 'customer',
            })
            // let opType = localStorage.getItem('operatorType')
            // let opName = localStorage.getItem('operatorName')
            // window.location.href = window.location.origin + `/?orderId=${orderObj.orderId}&platformKey=${this.platformKey}&operatorType=${opType}&operatorName=${opName}#/customer`;
            // window.location.replace();
          }

        }, 200);

      },
      getPlatformByKey() {
        // 获取运营商配置
        let oprInfo = this.oprInfo,
          channelIdAll = [],
          channelList = [].concat(oprInfo.channelListOfExternal, oprInfo.channelList);
        channelList.forEach((item) => {
          item.label = item.name;
          channelIdAll.push(item.id)
        });
        this.channelIdAll = channelIdAll;
        this.channelList = channelList;
        this.form.fromTypeList = [...channelIdAll];
      },
      getEnumTypesConfig(data) {
        // 获取枚举配置
        return this.server.get({
          name: 'getEnumTypes',
          data
        }).then(res => {
          return res.data
        })
      },
      getOrderStatus() {
        // 获取订单状态
        return this.getEnumTypesConfig({type: 2}).then((data) => {
          let list = [];
          if (data && data.length) {
            list = data.map((item) => {
              return {label: item.name, value: item.id}
            });
            list.unshift({label: '全部', value: '全部'})
          }
          this.orderStatusList = list;
          this.form.status = '全部'
        })
      },
      handleQuery() {
        // 查询订单列表
        let {form} = this,
          {consigneePhone, consigneeAddress, storeId} = form,
          today = format(Date.now(), 'yyyy-MM-dd'),
          startTime = new Date(form.startTime).getTime(),
          endTime = new Date(form.endTime).getTime(),
          differ = Math.abs(startTime - endTime),
          day = 24 * 60 * 60 * 1000,
          dayTotal = Math.floor(differ / day),
          state = false,
          validateFn = [],
          msg = '';
        validateFn.push(
          function () {
            if (consigneeAddress&&(storeId === null || storeId<=0 )) { // 地址判断
              state = true;
              msg = '请先查询门店，缩小数据范围'
            }
          },
          function () {
            if (!startTime || !endTime) {
              state = true;
              msg = '查询时间不能为空'
            }
          },
          function () {
            if (endTime < startTime) {
              state = true;
              msg = '开始时间不能大于结束时间,重置查询时间';
              form.startTime = today;
              form.endTime = today;
            }
          },
          function () {
            let max = 7, desc = '查询时间维度只能一周';
            if (typeof consigneeAddress === 'string' && consigneeAddress.length) {
              max = 0;
              desc = '查询时间维度只能一天'
            }
            if (dayTotal > max) {
              state = true;
              msg = desc
            }
          },
          function () {
            if (consigneePhone && !/^(\d{8}|\d{10}|\d{11}|(\d{3,4}-\d{8}))$/.test(consigneePhone)) {
              state = true;
              msg = '请输入正确的手机号码格式 8位/10位/11位/3位或4位区号-8位 数字'
            }
          });
        for (let fn of validateFn) {
          if (state) break;
          if (typeof fn === 'function') fn()
        }
        if (state) {
          return this.$Modal.error({
            title: '提示', content: msg
          })
        }
        form.pageNow = 1;
        this.getOrderList()
      },
      handleReset() {
        //重置查询字段
        let today = format(Date.now(), 'yyyy-MM-dd');
        this.form = {
          ...JSON.parse(form),
          startTime: today,
          endTime: today,
          fromTypeList: this.channelIdAll,
          status: '全部'
        };
        this.handleQuery()
      },
      changePaging(pageNow) {
        // 对分页进行判断
        let {form} = this,
          {pageTotal} = form;
        if (pageNow > 0 && pageNow <= pageTotal) {
          form.pageNow = pageNow;
          this.getOrderList()
        }
      },
      checkOrder(orderId) {
        //选中当前订单，获取订单详情
        if (this.orderId !== orderId) this.getOrderDetails(orderId);
      },
      showComplaint() {
        // 显示催单投诉
        let {complaint} = this,
          o = {
            checkValue: 2,
            complaintText: '',
            reminderText: '',
            remindText: '',
            callOrderTypeList: [],
            complaintBigReason: [],
            complaintSmallReason: [],
            reminderValue: null,
            complaintBigValue: null,
            complaintSmallValue: null,
          };
        each(o, (value, key) => {
          complaint[key] = value
        });
        this.getOrderWarning()
      },
      showCancelOrder() {
        //展示取消订单
        let {orderCancel} = this;
        orderCancel.visible = true;
        orderCancel.tips = '';
        orderCancel.childReasonValue = 0;
        orderCancel.reasonValue = 0;
        orderCancel.reasonList = [{name: '请选择原因', index: 0}];
        orderCancel.childReasonList = [{name: '请选择原因', index: 0}];
        this.getBigCancelReasons()
      },
      showAdjustStoreBefore() {
        // 打开门店调整前
        this.isAdjustOrderStore().then((res) => {
          if (res) {
            this.getAdjustableStoreList();
            this.getDistrictList();
            this.adjustStore.visible = true
          }
        })
      },
      changeAdjustStorePaging(pageNow) {
        //改变门店调整的分页
        let {adjustStore} = this,
          pageTotal = adjustStore.pageTotal;
        if (pageNow > 0 && pageNow <= pageTotal) {
          adjustStore.pageNow = pageNow;
          this.getAdjustableStoreList()
        }
      },
      queryAdjustableStoreList() {
        // 查询可调整门店
        let {adjustStore} = this;
        adjustStore.queryLoading = true;
        adjustStore.pageNow = 1;
        this.getAdjustableStoreList().finally(() => {
          adjustStore.queryLoading = false
        })
      },
      handleSearchBrandStore (key) {
        // 搜索品牌下的门店
        this.searchStoreList = [{storeName: '搜索中，请稍候..', canEdit: true}];
        this.throttle({
          callback() {
            this.server.get({
              name: 'findStoreList',
              data: {
                cityId: 0,
                districtId: 0,
                provinceId: 0,
                brandIdList: [this.brandId],
                storeName: key
              }
            }).then((res) => {
              let data = [{storeName: '查无该门店，请重新输入！', canEdit: true}];
              if (res.status === 1 && res.data && res.data.rows.length > 0) {
                data = res.data.rows
              }
              this.searchStoreList= data
            })
          },
          delay: 800,
          arg: [key]
        })
      },
      checkSearchBrandStore (store) { // 选择品牌下门店
        this.checkSearchBrandStoreAction(this.form, store)
      },
      handleSearchStore(key) {
        // 搜索门店
        this.adjustStore.searchStoreList = [{storeName: '搜索中，请稍候..', canEdit: true}];
        this.throttle({
          callback() {
            this.server.get({
              name: 'findStoreList',
              data: {
                storeName: key,
                pageNow: 1,
                pageSize: 9999
              }
            }).then((res) => {
              let data = [{storeName: '查无该门店，请重新输入！', canEdit: true}];
              if (res.status === 1 && res.data && res.data.rows.length > 0) {
                data = res.data.rows
              }
              this.adjustStore.searchStoreList = data
            })
          },
          delay: 800,
          arg: [key]
        })
      },
      clearSearchBrandStoreBefore () { // 清除品牌搜索门店的
        this.clearSearchStoreAction(this.form, this.searchStoreList)
      },
      clearSearchStoreAction (form, storeList) { // 清除门店操作
        //@param form = {} storeList = Array
        if (storeList.length === 0 || !find(storeList, (item) => item.storeName === form.storeName)) {
          storeList.splice(0, storeList.length);
          Object.assign(form, {
            storeName: '',
            storeId: null
          })
        }
      },
      checkSearchBrandStoreAction (form, store) {
        //选择门店操作
        if (store.storeId) {
          Object.assign(this.form, {
            storeId: store.storeId,
            storeName: store.storeName
          })
        }
      },
      checkSearchStore(store) { // 选中门店
        this.checkSearchBrandStoreAction(this.adjustStore, store);
      },
      clearSearchStore() { // 清除门店文本标记
        this.clearSearchStoreAction(this.adjustStore, this.adjustStore.searchStoreList);
      },
      resetAdjustableStore() {
        //重置可调整门店搜索条件
        let {adjustStore} = this;
        adjustStore.storeName = null;
        adjustStore.districtId = 0
      },
      submitAdjustStore(item) {
        // 提交修改门店
        let {orderObj, adjustStore} = this,
          {orderId} = orderObj;
        item.loading = true;
        this.server.get({
          name: 'manualAdjustOrderStore',
          data: {
            oldOrderId: orderId,
            newStoreId: item.storeId,
            isIntercept: true
          },
        }).then((res) => {
          let msg = res.msg;
          item.loading = false;
          if (res.status === 1) {
            adjustStore.visible = false;
            msg = '门店调整成功';
            // 暂时抛个定时器再去请求数据
            setTimeout(() => {
              this.handleQuery()
            }, 300)
          }
          this.$Modal.info({
            title: '提示',
            content: msg
          })
        })
      },
      checkComplaintBig(id) {
        // 选中投诉的大分类
        this.getEnumTypes(11, id).then((data) => {
          this.complaint.complaintSmallReason = data;
          this.complaint.complaintSmallValue = data.length ? data[0].id : null
        })
      },
      checkBigCancelReasons(index, name, value) {
        //选择取消订单的大原因
        if (index > 0) {
          this.getSmallCancelReasons(value.id)
        }
      },
      addOrderWarning() {
        //提交门店投诉
        let {complaint, orderId, isComplaintDisabled} = this,
          type = complaint.checkValue;
        this.server.get({
          name: 'addOrderWarning',
          data: {
            type,
            orderId,
            text: isComplaintDisabled
          }
        }).then((res) => {
          if (res.status === 1) {
            complaint.visible = false;
            this.$Modal.info({
              title: '提示',
              content: res.msg
            });
            this.getOrderDetails()
          }
        })
      },
      getOrderList() {
        // 获取订单列表
        let {brandId, form} = this,
          status = form.status === '全部' ? null : form.status;
        this.queryLoading = true;
        this.server
          .get({
            name: 'getOrderList',
            data: {
              brandId,
              ...form,
              status
            }
          })
          .then(res => {
            let data = res.data,
              pageTotal = 0,
              orderList = [];
            if (res.status === 1 && data.rows.length > 0) {
              orderList = data.rows;
              pageTotal = data.pages;
              this.getOrderDetails(orderList[0].orderId);
            }
            this.list = orderList;
            // this.$store.dispatch('booking/user/update', {
            //   orderList
            // });
            form.pageTotal = pageTotal
          }).finally(() => {
          this.queryLoading = false
        })
      },
      getOrderDetails(orderId) {
        // 获取订单详情
        orderId = orderId || this.orderId;
        let orderIdList = [orderId];
        this.isOrderLoading = true;
        this.server
          .get({
            name: 'getOrderDetail',
            data: {
              orderIdList
            }
          })
          .then(res => {
            let list = res.data;
            if (list.length > 0) {
              let data = list[0],
                order = data.order;
              this.orderProductOwns = data.orderProductOwns;
              this.order = list;
              this.orderObj = order;
              this.orderId = order.orderId;
              this.formatOrderRecord(data)
            }
          }).finally(() => {
          this.isOrderLoading = false
        })
      },
      formatOrderRecord(data) {
        // -1订单取消 格式化订单记录的
        let {hisRiderSendList = []} = data,
          o = {}, list = [], infoRecords = [],
          {progresses = [], cancelReason, cancelNote} = data.order;
        // 增加持续时间处理
        each(progresses, (value, index) => {
          let {createTime, status} = value,
            i = index + 1,
            next = progresses[i];
          if (next) {
            let differ = new Date(createTime).getTime() - new Date(next.createTime).getTime();
            next.durTime = formatTime(differ, 'hh:mm:ss')
          }
          if (index === 0) {
            if (status === 100 || status === -1) {
              value.durTime = ''
            } else {
              value.durTime = formatTime(Date.now() - new Date(createTime).getTime(), 'hh:mm:ss')
            }
          }
        });
        hisRiderSendList.reverse(); //反序
        [].concat(hisRiderSendList, progresses).forEach((value) => {
          let time = value.createTime,
            arr = o[time];
          if (!arr) {
            arr = o[time] = [];
            list.push(time)
          }
          arr.push(value);
        });
        list.sort(function (a, b) {
          return a > b ? -1 : a < b ? 1 : 0;
        });
        list.forEach(key => {
          let arr = o[key];
          if (arr && arr.length > 0) {
            infoRecords.push(...arr)
          }
        });
        each(infoRecords, (value) => {
          if (value.message) {
            value.sysNote = value.message;
            value.operaterName = value.companyName
          }
          if (value.status === -1) {
            value.sysNote += `(${cancelReason}${cancelNote ? '-' + 'cancelNote' : ''})`
          }
        });
        data.infoRecords = infoRecords
      },
      getOrderWarning() {
        // 催单投诉的数据
        let {order} = this,
          sendTime = new Date(order[0].order.sendTime).getTime(),
          orderId = this.orderId,
          now = Date.now(),
          minute = (now - sendTime) / (1000 * 60);
        this.server
          .get({
            name: 'getOrderWarning',
            data: {
              orderId
            }
          })
          .then(res => {
            let data = res.data,
              callOrderTypeList = data.callOrderTypeList || [],
              complaintBigReason = data.complaintBigReason || [],
              complaintBigValue = complaintBigReason.length ? complaintBigReason[0].id : null,
              reminderValue = null;
            complaintBigReason.length && this.checkComplaintBig(complaintBigValue);
            if (callOrderTypeList.length > 0) {
              // 催单的选择 根据预送达时间与现在时间进行想减，然后再去计算时间
              let num = callOrderTypeList.length - 1;
              find(callOrderTypeList, (value, index) => {
                let name = value.name,
                  arr = name.match(/(\d+)\D+(\d+)?/);
                if (arr && arr.length > 1) {
                  let min = arr[1], max = arr[2];
                  if ((min <= minute && minute <= max) || (!max && min <= minute)) {
                    num = index;
                    return true
                  }
                }
              });
              reminderValue = callOrderTypeList[num].id
            }
            each({
              callOrderTypeList,
              complaintBigReason,
              complaintBigValue,
              reminderValue,
              visible: true
            }, (value, key) => {
              console.log('改版本');
              this.complaint[key] = value
            })
          })
      },
      getEnumTypes(type, pid) {
        let orderObj = this.orderObj;
        // 获取投诉小分类
        return this.server.get({
          name: 'getEnumTypes',
          data: {
            type,
            pid,
            brandId: orderObj.brandId
          }
        }).then(res => {
          return res.data
        })
      },
      getBigCancelReasons() {
        // 获取取消一级原因
        let {orderObj, orderCancel} = this,
          {brandId} = orderObj,
          brandIds = [brandId];
        this.server.get({
          name: 'getBigCancelReasons',
          data: {
            brandIds
          }
        }).then(res => {
          let data = res.data;
          data.unshift({name: '请选择原因'});
          this.orderCancel.reasonList = data.map((value, index) => {
            value.index = index;
            return value
          })
        })
      },
      getSmallCancelReasons(bid) {
        // 获取二级取消原因
        let {orderObj, orderCancel} = this,
          {brandId} = orderObj,
          brandIds = [brandId];
        this.server.get({
          name: 'getSmallCancelReasons',
          data: {
            brandIds,
            bid
          }
        }).then(res => {
          let data = res.data || [];
          data.unshift({name: '请选择原因'});
          orderCancel.childReasonList = data.map((value, index) => {
            value.index = index;
            return value
          })
        })
      },
      getAdjustableStoreList() {
        //获取可调整配送的门店列表
        let {orderObj, adjustStore} = this,
          {districtId = null, pageNow, pageSize, storeName} = adjustStore,
          {brandId, storeId, cityId, longitude, latitude} = orderObj,
          coordinate = [longitude, latitude];
        return this.server.get({
          name: 'findAdjustableStoreList',
          data: {
            coordinate,
            excludeStoreId: [storeId],
            districtId,
            brandId,
            cityId,
            pageNow,
            pageSize,
            storeId: storeName ? adjustStore.storeId : null,
          }
        }).then(res => {
          let data = [],
            pageTotal = 0;
          if (res.status === 1) {
            data = res.data.rows;
            pageTotal = res.data.pages
          }
          adjustStore.pageTotal = pageTotal;
          adjustStore.storeList = data.map((value) => {
            value.loading = false;
            return value
          })
        })
      },
      getDistrictList() {
        //获取区域列表
        let {orderObj} = this,
          {cityId} = orderObj;
        return this.server.get({
          name: 'districtListByCity',
          data: {
            cityId
          }
        }).then(res => {
          let data = res.data || [];
          data.unshift({
            districtId: 0,
            name: '请选择'
          });
          this.adjustStore.districtList = data;
          return data
        })
      },
      isAdjustOrderStore() {
        // 判断是否能进行门店调整
        let {orderId} = this;
        this.AdjustLoading = true;
        return this.server.get({
          name: 'isAdjustOrderStore',
          data: {
            orderId,
          }
        }).catch(() => {
          return false
        }).finally(() => {
          this.AdjustLoading = false
        })
      },
      changeOrderStatus() {
        // 取消订单
        let {orderObj, orderCancel} = this,
          {orderId, status} = orderObj,
          {reasonList, childReasonList, reasonValue, childReasonValue, tips} = orderCancel,
          cancelBigReason = reasonList[reasonValue].id,
          cancelSmallReason = childReasonList[childReasonValue].id,
          name = 'addVerifyCancelOrder';
        // 1 7 状态直接ocrm取消状态 默认进行CC发起订单取消申请或者直接取消订单
        if (status === 1 || status === 7) {
          name = 'ocrmChangeOrderStatus'
        }
        this.server.get({
          name,
          data: {
            cancelBigReason,
            cancelSmallReason,
            tips,
            status: -1,
            orderId
          }
        }).then(() => {
          orderCancel.visible = false;
          this.$Modal.info({
            title: '提示',
            content: '操作成功'
          });
          return this.getOrderDetails();
        })
      }
    },
    components: {
      Tabs,
      TabPane,
      Button,
      Input,
      Modal,
      CcCalendar: Calendar,
      CcSelect,
      RadioGroup,
      Radio,
      ccLoadingBox: LoadingBox,
      CcInput,
      CcSelectCheck
    }
  }
</script>
<style lang="less" scoped>
  .history {
    margin-left: 15px;
    width: 1325px;
    .history-content {
      display: flex;
    }
    .order-empty {
      /*width: 730px;*/
      text-align: center;
      font-size: 18px;
      color: #989292;
    }
    .order-left {
      height: 100%;
      font-size: 12px;
      /*width: 350px;*/
      /*height: 498px;*/
      border: 1px solid #e5e8eb;
      display: flex;
      flex-direction: column;
    }
    .order-list {
      font-size: 12px;
      flex: 2;
    }
    .order-item {
      cursor: pointer;
      border-bottom: 1px solid #e5e8eb;
      line-height: 1.8;

      padding: 5px 8px;
      &.active, &:hover {
        background: rgb(235, 237, 239);
      }
    }
    .order-info-total {
      border: 1px solid #e5e8eb;
      display: flex;
      & > span {
        padding: 5px;
        flex: auto;
      }
      & > span:nth-child(odd) {
        background: rgb(238, 238, 238);
      }
      & > span:nth-child(even) {
        background: rgb(249, 249, 249)
      }
    }
    .order-details {
      margin-left: 15px;
      /*width: 834px;*/
      /*min-height: 498px;*/
      max-height: 850px;
      border: 1px solid #e5e8eb;
      position: relative;
    }
    .order-info-item {
      .form-item {
        margin: 0;
      }
    }
    .order-table {
      width: 100%;
      border: 1px solid #ededed;
    }
    .order-table > thead > tr {
      background-color: #fff;
      border-bottom: 1px solid #ededed;
    }
    .order-table-head > tr > th {
      color: #374174;
      font-weight: 700;
      padding: 10px 0 10px 20px;
    }
    .order-table-body td {
      color: #68768a;
      padding: 10px 0 10px 20px;
    }
    .order-table-striped > tbody > tr:nth-child(odd) > td {
      background: rgb(249, 249, 249);
    }
    .order-table-striped {
      border: none;
      .order-table-head > tr {
        border: none
      }
    }
    .order-combo {
      background-color: #fff;
    }
    /*.order-base-info {*/
    /*font-size: 14px;*/
    /*padding: 5px 0;*/
    /*&>div {*/
    /*padding: 5px 0;*/
    /*}*/
    /*}*/
    /*.order-action {*/
    /*padding: 5px 0;*/
    /*}*/
    /*.order-tabs /deep/ .tabs-content {*/
    /*}*/
  }

  .complaint, .order-cancel-form {
    .form-item .form-item-label {
      width: 120px;
      text-align: right;
    }
  }

  .am-table {
    width: 100%;
    border-spacing: 0;
    border-collapse: separate;
    max-width: 100%;
    background-color: transparent;
    empty-cells: show;
    & > thead > tr > th {
      vertical-align: bottom;
      border-bottom: 1px solid #ddd;
      padding: .7rem;
      line-height: 1.6;
    }
    & > tbody > tr > td {
      padding: .7rem;
      line-height: 1.6;
      vertical-align: middle;
      border-top: 1px solid #ddd;
    }
  }

  .am-table-bordered {
    border: 1px solid #ddd;
    border-left: none;
    & > thead > tr > th {
      border-left: 1px solid #ddd;
    }
    & > tbody > tr > td {
      border-left: 1px solid #ddd;
    }
  }

  .paging-contain {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    .paging-item {
      padding: 0 10px;
    }
  }

  .am-textarea {
    width: 480px;
    height: 68px;
  }

  .w300 {
    width: 300px;
  }

  .w200 {
    width: 200px;
  }

  .w90 {
    width: 90px;
  }

  .w100 {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// pagesCache/orderList/orderList.vue